import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Checkbox, FormControlLabel, Typography} from "@material-ui/core";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../Utils";
import findByString from "../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Utils/lib";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {setArrayPath} from "../../../../Utils/Form/FormDynamic/Utils/setArrayPath";
import {useDeepCompareMemo} from "use-deep-compare";

const CheckboxComponent = (props) => {
    const [checkboxValue, setCheckBoxValue] = useState(null);
    const [onChangeAction, setOnChangeAction] = useState([])
    const {element, globalValues, screenName, actionsContext, doActions, containerArrayPath} = props;
    const {properties, styles: sourceStyles, events} = element;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = getParamsFromString(multiLanguageValue(properties.label, userLanguage), {...globalValues, ...actionsContext}, screenName);
    const path = getParamsFromString(element.properties.path, {...globalValues, ...actionsContext}, screenName) || false;
    const splited = path.split('.');
    const isArr = !isNaN(splited[splited.length - 1]);

    const value = getParamsFromString(properties.value, {...globalValues, ...actionsContext}, screenName);

    const isDisabled = useDeepCompareMemo(() => {
        return checkHidden({...globalValues, ...actionsContext}, properties.disabled, screenName);
    }, [globalValues, actionsContext, properties.disabled, screenName])

    const isHidden = useDeepCompareMemo(() => {
        return checkHidden({...globalValues, ...actionsContext}, properties.hideCondition, screenName);
    }, [globalValues, actionsContext, properties.hideCondition, screenName])

    useEffect(() => {
        if (value && !checkboxValue) {
            setCheckBoxValue(value);
        }
    }, [value])
    useEffect(() => {
        const actions = events ? events[0] ? events[0].actions : undefined : undefined;
        if (actions) {
            if (actions.length) {
                setOnChangeAction(actions)
                return;
            }
            setOnChangeAction(onChangeAction);
        }
    }, []);

    const isChecked = useDeepCompareMemo(() => {
        if(props.containerArrayPath) {
            const arrayPath = setArrayPath(path, props.containerArrayPath);
            return Boolean(findByString({...globalValues.param[screenName], ...actionsContext}, arrayPath))
        }

        if (properties.value) {
            const withoutIndex = splited.slice(0, -1);
            const arrayPath = withoutIndex.join('.');
            const sourceArray = findByString(globalValues.param[screenName], arrayPath) || [];
            if (isArr) {
                return sourceArray.indexOf(checkboxValue) !== -1;
            }
        }
        const value = findByString({...globalValues.param[screenName], ...actionsContext}, path);
        if (typeof value === "string") {
            return value === 'true';
        }
        if (typeof value === 'boolean') {
            return value;
        }
        return false;
    }, [
        path,
        containerArrayPath,
        properties,
        screenName,
        actionsContext,
        splited,
        globalValues,
        isArr,
        checkboxValue
    ])

    function onChange(e) {
        if (isArr) {
            let withoutIndex = splited.slice(0, -1);
            let arrayPath = withoutIndex.join('.');
            let sourceArray = findByString(globalValues.param[screenName], arrayPath) || [];
            let newArr = e.target.checked ? [...sourceArray, checkboxValue] : sourceArray.filter(i => i !== checkboxValue);
            props.setValue(newArr, arrayPath)
            if (onChangeAction) {
                doActions([onChangeAction], {currentValue: newArr});
            }
            return
        }
        const currentValue = checkboxValue ? e.target.checked ? checkboxValue : false : e.target.checked;
        let currentPath = props.containerArrayPath ? setArrayPath(path, props.containerArrayPath) : path;
        props.setValue(currentValue, currentPath)
        doActions(onChangeAction, {currentField: {value: currentValue}, currentValue});
    }

    if (isHidden) return <></>

    return (
        <FormControlLabel
            labelPlacement={styles.labelPlacement}
            style={{
                margin: 0,
                fontSize: styles.fontSize,
                fontWeight: styles.fontWeight,
                fontStyle: styles.fontStyle,
                textDecoration: styles.textDecoration,
                color: styles.color,
            }}
            onClick={e => e.stopPropagation()}
            control={
                <Checkbox
                    disabled={isDisabled}
                    checked={isChecked}
                    onChange={onChange}
                    size={styles.size}
                    onClick={e => e.stopPropagation()}
                />}
            label={<Typography style={{fontSize: styles.fontSize}}>{multiLanguageLabel}</Typography>}
        />
    )
}
export default JsonScreenHoc(CheckboxComponent)

CheckboxComponent.propTypes = {
    element: PropTypes.shape({
        properties: PropTypes.shape({
            label: PropTypes.object,
            value: PropTypes.string,
            path: PropTypes.string
        }),
        styles: PropTypes.array,
        events: PropTypes.array,
    }),
    globalValues: PropTypes.object,
    screenName: PropTypes.string,
    setValue: PropTypes.func
}
